import { Offer } from './types'

// Mock data for demo purposes - media specifications for billboards/banners
export const mockOffers: Offer[] = [
  {
    id: 1,
    offer_number: 'OTS-135715',
    location: 'CHISINAU - STR.CIUFLEA/STR.BUCURESTI',
    media_type: 'video',
    format: 'mp4',
    proportions: '16x9',
    resolution: '1920 x 1080',
    frames_per_second: 30,
    duration_seconds: 10,
    font_size_minimum: 25,
    maximum_contrast: true,
    price: 2500,
    currency: 'EUR',
    status: 'approved',
    created_at: '2024-01-15T10:30:00Z',
    start_date: '2024-02-01',
    end_date: '2024-04-30'
  },
  {
    id: 2,
    offer_number: 'OTS-135716',
    location: 'CHISINAU - City Center, Main Street',
    media_type: 'static_image',
    format: 'jpg, png: RGB',
    proportions: '16x9',
    resolution: '1920 x 1080',
    font_size_minimum: 25,
    maximum_contrast: true,
    price: 1800,
    currency: 'EUR',
    status: 'pending',
    created_at: '2024-01-20T14:15:00Z',
    start_date: '2024-03-01',
    end_date: '2024-05-31'
  },
  {
    id: 3,
    offer_number: 'OTS-135717',
    location: 'CHISINAU - Shopping Mall Entrance',
    media_type: 'video',
    format: 'mp4',
    proportions: '16x9',
    resolution: '1920 x 1080',
    frames_per_second: 30,
    duration_seconds: 10,
    font_size_minimum: 25,
    maximum_contrast: true,
    price: 3200,
    currency: 'EUR',
    status: 'active',
    created_at: '2024-01-10T09:00:00Z',
    start_date: '2024-01-15',
    end_date: '2024-06-15'
  },
  {
    id: 4,
    offer_number: 'OTS-135718',
    location: 'CHISINAU - Airport Terminal',
    media_type: 'static_image',
    format: 'jpg, png: RGB',
    proportions: '16x9',
    resolution: '1920 x 1080',
    font_size_minimum: 25,
    maximum_contrast: true,
    price: 4200,
    currency: 'EUR',
    status: 'rejected',
    created_at: '2024-01-08T11:45:00Z',
    start_date: '2024-02-15',
    end_date: '2024-07-15'
  },
  {
    id: 5,
    offer_number: 'OTS-135719',
    location: 'CHISINAU - Stadium Area',
    media_type: 'video',
    format: 'mp4',
    proportions: '16x9',
    resolution: '1920 x 1080',
    frames_per_second: 30,
    duration_seconds: 10,
    font_size_minimum: 25,
    maximum_contrast: true,
    price: 5500,
    currency: 'EUR',
    status: 'approved',
    created_at: '2024-01-25T16:20:00Z',
    start_date: '2024-03-15',
    end_date: '2024-08-15'
  },
  {
    id: 6,
    offer_number: 'OTS-135720',
    location: 'CHISINAU - Subway Station',
    media_type: 'static_image',
    format: 'jpg, png: RGB',
    proportions: '16x9',
    resolution: '1920 x 1080',
    font_size_minimum: 25,
    maximum_contrast: true,
    price: 1200,
    currency: 'EUR',
    status: 'expired',
    created_at: '2023-12-20T13:10:00Z',
    start_date: '2023-12-25',
    end_date: '2024-01-25'
  },
  {
    id: 7,
    offer_number: 'OTS-135721',
    location: 'CHISINAU - Business District',
    media_type: 'video',
    format: 'mp4',
    proportions: '16x9',
    resolution: '1920 x 1080',
    frames_per_second: 30,
    duration_seconds: 10,
    font_size_minimum: 25,
    maximum_contrast: true,
    price: 2800,
    currency: 'EUR',
    status: 'pending',
    created_at: '2024-01-28T10:00:00Z',
    start_date: '2024-04-01',
    end_date: '2024-09-30'
  }
]
